// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"Faq_faqContainer__drnc1"};